import React, { ReactNode, useContext, useState } from "react";
import { MSelect } from "components/Shared";
import { PdfDisplayControl, PdfDisplayDefinition } from "interfaces/Phoenix.FormsDesigner.Models";
import { MSelectOption } from "components/Shared/MSelect";

export interface PdfImportChanges {
  removed: PdfRemovedControl[],
  repeatChildrenAdded: PdfDisplayControlChild[],
  rootControlsAdded: PdfDisplayControlChild[],
}

export interface PdfDisplayControlChild {
  parentId: string,
  control: PdfDisplayControl
}

export interface PdfRemovedControl {
  name: string,
  id: string
}

interface Props {
  pdfImportChanges: PdfImportChanges,
  pdfDefinition: PdfDisplayDefinition
}

const ImportChangesDialog = ({ pdfImportChanges, pdfDefinition }: Props) => {

  const onSectionChange = (id: string, item: PdfDisplayControlChild) => {
    console.log(pdfDefinition)
    item.parentId = id;
  };

  return (
    <div className="import-changes-space">
      <div className="bg-white rounded shadow-xl w-full max-w-2xl">

        <h3 className="import-changes-header">Controls Added</h3>
        <table className="import-changes-table">
          <tbody>
            {pdfImportChanges.rootControlsAdded.length === 0 ? (
              <tr><td className="import-changes-option">None</td></tr>
            ) : (
              pdfImportChanges.rootControlsAdded.map((item, i) => (
                <tr key={i}>
                  <td className="import-changes-option">{item.control?.name}</td>
                  <td className="import-changes-selector"><MSelect
                    placeholder="Select section:"
                    options={pdfDefinition.displayControls.map(s => ({ value: s.id, label: s.name }))}
                    onChange={(newValue: MSelectOption<string>) => onSectionChange(newValue.value, item)}
                    defaultValue={{ label: pdfDefinition.displayControls[0].name, value: pdfDefinition.displayControls[0].id }}
                  /></td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <h3 className="import-changes-header">Repeat Children Added</h3>
        <table className="import-changes-table">
          <tbody>
            {pdfImportChanges.repeatChildrenAdded.length === 0 ? (
              <tr><td className="import-changes-option">None</td></tr>
            ) : (
              pdfImportChanges.repeatChildrenAdded.map((item, i) => (
                <tr key={i}><td className="import-changes-option">{item.control?.name}</td></tr>
              ))
            )}
          </tbody>
        </table>

        <h3 className="import-changes-header">Controls Removed</h3>
        <table className="import-changes-table">
          <tbody>
            {pdfImportChanges.removed.length === 0 ? (
              <tr><td className="import-changes-option">None</td></tr>
            ) : (
              pdfImportChanges.removed.map((item, i) => (
                <tr key={i}><td className="import-changes-option">{item.name}</td></tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ImportChangesDialog;


